'use client'

import { defaultDrops, ITravelPointQuote } from '@repo/sdk'
import {
  Button,
  DateTimeInput,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@repo/ui'
import { Card, CardContent } from '@repo/ui/components'
import { useDropsContext } from '@repo/ui/forms'
import { LocationInput } from '@repo/ui/inputs'
import { CirclePlus, Trash2 } from 'lucide-react'
import { Control, useFormContext } from 'react-hook-form'

interface Props {
  addStop?: boolean
  control: Control<{ drops: ITravelPointQuote[] }>
  drop: ITravelPointQuote
  index: number
  isAdmin?: boolean
  showType?: boolean
  title: string
}

export const LocationAndDate = ({
  addStop = false,
  control,
  index,
  isAdmin = false,
  // showType = false,
  title,
}: Props) => {
  const { getFieldState } = useFormContext<{ drops: ITravelPointQuote[] }>()

  const { drops, insertDrop, removeDrop } = useDropsContext()

  const isIndex = index !== -1

  const handleAddStop = () => {
    isIndex && insertDrop(index + 1, defaultDrops(drops.length))
  }

  const dateState = getFieldState(`drops.${index}.date`)
  const timeState = getFieldState(`drops.${index}.time`)

  const isDateTimeError = [dateState, timeState].map(state => state.error).filter(Boolean)

  return (
    <div>
      {/* <div
        className={cn(
          'absolute right-full mr-4 flex h-full w-4 translate-y-4',
          index !== 0 ? 'route-stop' : '',
        )}
      >
        <div className={cn('z-20 h-4 w-full rounded-full bg-brand')} />
      </div> */}

      <Card className="relative">
        <div className="absolute right-full top-[18px] z-20 mr-3 aspect-square w-4 rounded-full bg-brand" />
        <CardContent className={'grid w-full grid-cols-1 items-center gap-2 md:grid-cols-2'}>
          <FormField
            control={control}
            name={`drops.${index}.place`}
            render={({ field }) => {
              return (
                <FormItem className={'flex grow basis-0 flex-col'}>
                  <FormLabel className={'text-md w-full text-card-foreground'}>{title}</FormLabel>
                  <FormControl className={'w-full'}>
                    <LocationInput {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )
            }}
          />
          {/*<PlaceDetailsBox control={control} index={index} />*/}
          <FormItem className={'flex grow basis-0 flex-col'}>
            <FormLabel className={'text-md text-card-foreground'}>Date & time</FormLabel>
            <FormControl>
              {/*@ts-ignore*/}
              <DateTimeInput control={control} index={index} isAdmin={isAdmin} />
            </FormControl>
            {isDateTimeError.map((error, index) => (
              <FormMessage key={error!.ref?.name ?? `error_date_time_${index}`}>
                {error!.message}
              </FormMessage>
            ))}
          </FormItem>

          <div className="mt-8 w-10 max-md:justify-self-end">
            {index > 0 && index < drops.length - 1 && (
              <Button
                className="aspect-square w-full"
                onClick={() => isIndex && removeDrop(index)}
                type={'button'}
                variant={'ghost'}
              >
                <Trash2 className={'stroke-brand'} />
              </Button>
            )}
          </div>
        </CardContent>
      </Card>
      {addStop && (
        <div
          className="relative ml-4 mt-2 flex w-fit cursor-pointer items-center gap-2 rounded bg-background p-1.5 transition-[filter] hover:brightness-95"
          onClick={handleAddStop}
        >
          <div className="absolute right-full z-20 mr-[28px] aspect-square w-[14px] rounded-full border border-brand bg-background" />
          <CirclePlus className="text-brand" />
          Add stop
        </div>
      )}
    </div>
  )
}

// const PlaceDetailsBox = ({
//   control,
//   index,
// }: {
//   control: Control<{ drops: ITravelPointQuote[] }>
//   index: number
// }) => {
//   const { field } = useController({ control, name: `drops.${index}.place` })
//
//   const { data: addressData } = useQuery({
//     async queryFn() {
//       if (!field.value) return
//
//       return getLatLng(field.value.place_id ?? '')
//     },
//     queryKey: ['geolocation.cargoking.co.uk/google/place/details'', field.value],
//   })
//
//   if (!field.value) return null
//
//   const formattedAddress = addressFormatter(addressData?.address_components)
//
//   return (
//     <div className={'rounded bg-[#F4F7FB] p-2.5 text-sm font-semibold dark:bg-[#262626]'}>
//       <p>
//         {formattedAddress?.premise} {formattedAddress?.address}
//       </p>
//       <p>
//         {formattedAddress?.city} {formattedAddress?.postcode}
//       </p>
//       <p>{formattedAddress?.countryCode}</p>
//     </div>
//   )
// }
